import { useState } from "react";
import { type EditorOps } from "./editorCore";

export const useClone = (ops: EditorOps, setOps: (ops: EditorOps) => void) => {
  const [cloneFrom, setCloneFrom] = useState<{ x: number; y: number } | null>(
    null
  );
  const [previewClonePos, setPreviewClonePos] = useState<{
    x: number;
    y: number;
  } | null>(null);
  const [cloneSize, setCloneSize] = useState(50);

  const onMouseDown = (x: number, y: number) => {
    if (!cloneFrom) setCloneFrom({ x, y });
    else {
      const fromOrig = { x: cloneFrom.x, y: cloneFrom.y };
      const toOrig = { x, y };
      setOps({
        ...ops,
        clonar: [
          ...(ops.clonar || []),
          { from: fromOrig, to: toOrig, size: cloneSize },
        ],
      });
      setCloneFrom(null);
      setPreviewClonePos(null);
    }
  };

  const onMouseMove = (x: number, y: number) => {
    if (cloneFrom) setPreviewClonePos({ x, y });
  };

  const onMouseUp = () => {};

  const renderOverlay = (ctx: CanvasRenderingContext2D) => {
    if (!cloneFrom || !previewClonePos) return;
    const size = cloneSize;
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = size;
    tempCanvas.height = size;
    const tempCtx = tempCanvas.getContext("2d")!;
    tempCtx.drawImage(
      ctx.canvas,
      cloneFrom.x - size / 2,
      cloneFrom.y - size / 2,
      size,
      size,
      0,
      0,
      size,
      size
    );
    tempCtx.globalCompositeOperation = "destination-in";
    tempCtx.beginPath();
    tempCtx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
    tempCtx.fill();
    ctx.drawImage(
      tempCanvas,
      previewClonePos.x - size / 2,
      previewClonePos.y - size / 2
    );
  };

  const control = (
    <div>
      <label>Tamaño</label>
      <input
        type="range"
        min={10}
        max={200}
        value={cloneSize}
        onChange={(e) => setCloneSize(+e.target.value)}
      />
      {ops.clonar?.length > 0 && (
        <button
          className="btn btn-default"
          onClick={() => setOps({ ...ops, clonar: ops.clonar.slice(0, -1) })}
        >
          Deshacer Clonación
        </button>
      )}
    </div>
  );

  return { control, onMouseDown, onMouseMove, onMouseUp, renderOverlay };
};
